import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "../styles/CollapsibleColumn.css";

const CollapsibleColumn = ({ title, links, singleLink }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  const isExternalLink = (url) => {
    return url.startsWith("http") || url.startsWith("www");
  };

  if ((!links || links.length === 0) && singleLink) {
    // If no links and singleLink is provided
    return (
      <div className="collapsible-column-section">
        <NavLink
          to={singleLink}
          className="collapsible-column-title single-link"
        >
          {title}
        </NavLink>
      </div>
    );
  }

  return (
    <div className="collapsible-column-section">
      <div className="collapsible-column-title" onClick={toggleExpand}>
        {title}
      </div>
      <ul
        className={`collapsible-column-links ${isExpanded ? "expanded" : ""}`}
      >
        {links.map((link, index) => (
          <li key={index} className="collapsible-column-link">
            {isExternalLink(link.to) ? (
              <a
                href={link.to}
                target="_blank"
                rel="noopener noreferrer"
                className="nav-link"
              >
                {link.label}
              </a>
            ) : (
              <NavLink
                to={link.to}
                className={({ isActive }) =>
                  isActive ? "nav-link active" : "nav-link"
                }
              >
                {link.label}
              </NavLink>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default CollapsibleColumn;
